
const { NODE_ENV } = process.env;
const BUILD_ENV = process.env.BUILD_ENV;
export const __DEV__ = NODE_ENV === 'development';

export const SSO_PATH = __DEV__
  ? 'http://sso.hfrong.cn:81'
  : BUILD_ENV === 'test'
    ? 'http://sso.hfrong.cn:81'
    : 'http://netseek.fangefly.cn'
